module.exports = __webpack_public_path__ + "img/culinarian.a2f05b27.png";